import { render, staticRenderFns } from "./otherGraph.vue?vue&type=template&id=15a5c390&scoped=true&"
import script from "./otherGraph.vue?vue&type=script&lang=js&"
export * from "./otherGraph.vue?vue&type=script&lang=js&"
import style0 from "./otherGraph.vue?vue&type=style&index=0&id=15a5c390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a5c390",
  null
  
)

export default component.exports